import { withAlpha } from './color';
import meridianOrangePalette from './meridian-orange';

export function accentHoverColor(isDarkMode: boolean): string {
  return withAlpha(meridianOrangePalette.palette300, isDarkMode ? 0.08 : 0.07);
}

export function accentPressedColor(isDarkMode: boolean): string {
  return withAlpha(meridianOrangePalette.palette300, isDarkMode ? 0.22 : 0.16);
}
